function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import Cookies from 'js-cookie';
var currentHash = '';
var currentEventType = '';
var roomsTypes = {
    '1': 'Студия',
    '2': '1 комната',
    '3': '2 комнаты',
    '4': '3 комнаты',
    '5': '4 комнаты'
};
var startSession = function() {
    var sessionSS = sessionStorage.getItem('_slsession');
    console.log('startSession:', localStorage.getItem('start_session'), sessionSS);
    if (localStorage.getItem('start_session') !== sessionSS && typeof smAnalytics !== 'undefined') {
        sendEvent({
            name: 'Login',
            properties: {
                eventType: 'login-v1',
                cuid: smAnalytics.getPeopleId(),
                cuidType: 'Smartis ID'
            }
        });
        localStorage.setItem('start_session', sessionSS);
    }
};
window.sendSPA = function() {
    var SL = window.SL;
    if (typeof SL.API === 'undefined') {
        console.log('SL.API is undefined');
    } else {
        var pathname = window.location.pathname;
        var eventType = '';
        var type = '';
        var data = '';
        var context = {};
        if (pathname === '/') {
            var hash = window.location.hash;
            if (hash === '' || hash === '#' || hash === '#home') {
                type = 'HOMEPAGE';
                eventType = 'HOMEPAGE';
            } else if (hash === '#apartments') {
                if (document.querySelector('[data-room-tab="params"]').classList.contains('rooms-tabs__item_open')) {
                    type = 'CATEGORY';
                    data = [
                        'Квартира'
                    ];
                    document.querySelectorAll('[data-filters] input[name="room-type"]:checked').forEach(function(item) {
                        data.push(roomsTypes[item.value]);
                    });
                    eventType = 'CATEGORY_' + data.join('_');
                } else {
                    type = 'OTHER';
                    eventType = 'OTHER';
                }
            } else {
                type = 'OTHER';
                eventType = 'OTHER';
            }
        } else if (pathname.includes('/apartments/')) {
            type = 'PRODUCT';
            eventType = 'PRODUCT';
            var id = document.querySelector('.room') ? document.querySelector('.room').getAttribute('data-flat-id') : null;
            if (id) {
                data = [
                    id
                ];
                eventType = 'PRODUCT_' + id;
            }
        } else {
            type = 'OTHER';
            eventType = 'OTHER';
        }
        if (currentEventType != eventType) {
            if (data !== '') {
                context = {
                    type: type,
                    data: data
                };
            } else {
                context = {
                    type: type
                };
            }
            var url = window.location.href;
            console.log('sendSPA:', context, url);
            SL.API('spa', {
                context: context,
                url: url,
                countAsPageview: true
            });
            currentEventType = eventType;
        }
    }
};
window.sendEvent = function(params) {
    var SL = window.SL;
    if (typeof SL.API === 'undefined') {
        console.log('SL.API is undefined');
    } else {
        console.log('sendEvent:', params);
        SL.API('event', params);
    }
};
window.addEventListener('load', function() {
    startSession();
    sendSPA();
    if (window.location.pathname === '/') {
        document.addEventListener('scroll', function() {
            var hash = window.location.hash;
            if (hash !== currentHash) {
                sendSPA();
                currentHash = hash;
            }
        });
        if (document.querySelectorAll('[data-room-tab-change]')) {
            document.querySelectorAll('[data-room-tab-change]').forEach(function(item) {
                item.addEventListener('click', function() {
                    setTimeout(function() {
                        sendSPA();
                    }, 300);
                });
            });
        }
        if (document.querySelectorAll('[data-filters] input[name="room-type"]')) {
            document.querySelectorAll('[data-filters] input[name="room-type"]').forEach(function(item) {
                item.addEventListener('change', function() {
                    setTimeout(function() {
                        sendSPA();
                    }, 100);
                });
            });
        }
    }
    if (document.querySelector('.button[href="#flat-request"]')) {
        document.querySelector('.button[href="#flat-request"]').addEventListener('click', function() {
            var flat = document.querySelector('.room');
            if (flat) {
                var flatID = flat.getAttribute('data-flat-id');
                var flatPrice = parseFloat(flat.getAttribute('data-flat-price'));
                sendEvent({
                    name: 'Add to Cart',
                    properties: {
                        eventType: 'add-to-cart-v1',
                        addtocart_type: 'flat',
                        productId: flatID,
                        value: flatPrice,
                        currency: 'RUB',
                        quantity: 1,
                        cart: [
                            {
                                productId: flatID,
                                itemPrice: flatPrice,
                                quantity: 1
                            }
                        ]
                    }
                });
            }
        });
    }
});
/* Методы для кампаний */ // Метод получения состава избранного
window.getFavoritesList = function() {
    var name = 'fav';
    if (!Cookies.get(name)) return [];
    return JSON.parse(Cookies.get(name));
};
// Метод добавления в избранное
window.addToFavorites = function(id) {
    var list = getFavoritesList();
    var value = id ? _to_consumable_array(new Set(_to_consumable_array(list).concat([
        id
    ]))) : list;
    Cookies.set('fav', JSON.stringify(value), {
        path: '/'
    });
};
